var myScript = document.currentScript,
    mySrc = myScript.getAttribute('data-origin');
(function ($) {
  $(function(){

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var header = $('header.navbar-default');
    var backToStep = $('#back-to-site');
    var headerHeight = $('header.navbar-default').outerHeight();
    var body = $('body');
    // body.css({"padding-top": headerHeight * 4});

    $('body').scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 50);

    function hasScrolled() {
      var st = body.scrollTop();

      if(Math.abs(lastScrollTop - st) <= delta)
          return;
      if (st > lastScrollTop && st > headerHeight){
          header.removeClass('nav-up').addClass('nav-down');
          backToStep.removeClass('nav-up').addClass('nav-down');
      } else {
        if(st + $(window).height() < $(document).height()) {
          header.removeClass('nav-down').addClass('nav-up');
          backToStep.removeClass('nav-down').addClass('nav-up');
        }
      }

      lastScrollTop = st;
    }

    $('body').on('scroll', function() {
      var scroll = $('body').scrollTop();

      if (scroll >= 80) {
          header.addClass('active-background');
          body.addClass('scrolled');
      } else {
          header.removeClass('active-background');
          body.removeClass('scrolled');
      }
    });

    var attivitaRow = $('.row.museum-production__row');
    var poweredBy = $('#poweredBy');
    attivitaRow.closest('.col-lg-12').css('display', 'none');
    poweredBy.closest('.row').css('display', 'none');
  });

  // Replace upsselling link with url to step website.
  $(document).ready(function() {
    function getParameterByName(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    var dest = mySrc + '/eventSearch/';
    var $upsell = $('.evt-articles-upselling h3[id^="event-title"] a');
    $upsell.each(function (index, item) {
      var $upsellHref = $(item).attr('href');
      var eventId = getParameterByName('eventId', $upsellHref);
      $(item).attr('href', dest + eventId)
        .attr('target', '_blank');
    });

    function addEventLink() {
      var $eventList = $('.evt-event-list[id^="eventKey:"]');
      $eventList.each(function (index, item) {
        if ($(item).hasClass('event-link-processed')) {
          return;
        }
        var id = item.id.replace('eventKey:', '');
        var link = $('<a>').attr('target', '_blank').attr('href', dest + id );
        $('h2#event-title-' + id, item).wrapInner(link);
        $(item).addClass('event-link-processed');
      })
    }
    addEventLink();
    setTimeout(addEventLink, 1000);
    $('#moreEventsButton').on('click', function() {
      setTimeout(addEventLink, 1000);
    });

  })
  $(document).ready(function(){
    $("div[class*='timeslot-calendar']").click(function() {
      setTimeout(
        function() {
          if (globals.actPage == "timeslot") {
            for (var i = 0; i < document.getElementsByTagName("div").length; i++) {
            if (document.getElementsByTagName("div")[i].className == "timeslot-time__slot" || document.getElementsByTagName("div")[i].className == "timeslot-time__slot hidden") {
              var time = document.getElementsByTagName("div")[i].innerHTML;
              document.getElementsByTagName("div")[i].innerHTML = time.substr(0,5);
            }
          }
        }
      }, 1500);
    });
  });

  $(document).ready(function(){
    $("div[class*='timeslot-time']").click(function() {
      setTimeout(
        function() {
        if (globals.actPage == "timeslot") {
          for (var i = 0; i < document.getElementsByTagName("span").length; i++) {
            if (document.getElementsByTagName("span")[i].className == "seatgroup__eventtime") {
              var time = document.getElementsByTagName("span")[i].innerHTML;
              document.getElementsByTagName("span")[i].innerHTML = time.substr(0,5);
            }
          }
        }
      }, 1500);
    });
  });
  $(document).on('click', '.ot-sdk-show-settings', function () {
    Cookiebot.show();
  })
  window.addEventListener("CookiebotOnDialogDisplay", function (e) {
    document.body.style.paddingTop = null
    const detailCategories = ["Preference", "Statistics", "Advertising", "Unclassified"],
      toggleCategories = ["Preferences", "Statistics", "Marketing"];
    detailCategories.forEach(function (e) {
      if (CookieConsentDialog["cookieTable" + e + "Count"] === 0) {
        document.getElementById(
          "CybotCookiebotDialogDetailBodyContentCookieContainer" + e + "Card"
        ).parentNode.style.display = "none";
      }
    });
    for (i = 0; i < 3; i++) {
      if (CookieConsentDialog["cookieTable" + detailCategories[i] + "Count"] === 0)
        document.querySelector(
          "label[for=CybotCookiebotDialogBodyLevelButton" + toggleCategories[i] + "]"
        ).parentNode.style.display = "none";
    }
  }, !1)
})(jQuery)

